import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import AlertModal from 'components/common-components/AlertModal';
import AttachmentsOverviewContent from 'pages/submissions/AttachmentsOverviewContent';
import SingleCheckBoxField from 'components/form-components/SingleCheckBoxField';
import attendanceMediaIcon from 'assets/images/icons/attendance-media.svg';
import attendanceMediaGreyIcon from 'assets/images/icons/attendance-media-grey.svg';
import TableUtils from 'components/table-component/TableUtils';

const TableData = ({
  data,
  tableFields,
  props,
  isActionsEnabled,
  onSelection,
  isSelectionEnabled,
  selectionKey,
  selectedRows,
  cellBorder,
  noWrap,
}) => {
  let { actionsType, actionsCallBack, type, attendanceMediaNote, translateValueFunc } = {
    ...props,
  };
  const trCellBorderClass =
    cellBorder === 'horizontal' || cellBorder === 'both' ? 'cell-border-horizontal' : '';
  const tdCellBorderClass =
    cellBorder === 'vertical' || cellBorder === 'both' ? 'cell-border-vertical' : '';
  const [showMediaModal, setShowMediaModal] = useState(false);
  const [mediaAndNotes, setMediaAndNotes] = useState({
    media: [],
    note: '',
    showTimeStamp: false,
    mediaTimeStampString: {},
    dialogType: '',
  });
  const showMedia = (mediaNotes, formVersionId, showTimeStamp, dialogType) => {
    setShowMediaModal(true);
    setMediaAndNotes({
      ...mediaNotes,
      showTimeStamp: false,
      mediaTimeStampString: {},
      dialogType,
    });
  };
  const closeModal = () => {
    setShowMediaModal(false);
    setMediaAndNotes({ media: [], note: '' });
  };

  return (
    <Fragment>
      <tbody className={`${trCellBorderClass} ${tdCellBorderClass}`}>
        {data &&
          data.map((singleRecord, index) => {
            return (
              <tr key={index} className={trCellBorderClass}>
                {isSelectionEnabled ? (
                  <td className='table-checkbox'>
                    <SingleCheckBoxField
                      name={selectionKey.split('.').reduce((acc, curr) => acc[curr], singleRecord)}
                      value={
                        selectedRows
                          .map((e) => (e.id ? e.id : e))
                          .indexOf(
                            selectionKey.split('.').reduce((acc, curr) => acc[curr], singleRecord),
                          ) > -1
                          ? true
                          : false
                      }
                      handleChange={onSelection}
                      disabled={
                        type === 'submissions' && singleRecord.entryStatus !== 'complete_entry'
                      }
                      shrink
                      classes=''
                    />
                  </td>
                ) : null}
                {tableFields.map((singleHeaderField, index1) => {
                  let value = singleHeaderField.associatedKey;
                  let callbackFunc = singleHeaderField.callbackFunc
                    ? props[singleHeaderField.callbackFunc]
                    : null;
                  return singleHeaderField.isSelected ? (
                    <td
                      key={index1}
                      className={noWrap || singleHeaderField.noWrap ? 'text-nowrap' : ''}
                      // className={type === 'data_source_filter_list' ? 'nowrap' : ''}
                    >
                      {type === 'attendance' &&
                      attendanceMediaNote &&
                      singleRecord &&
                      singleRecord._id &&
                      attendanceMediaNote[singleRecord._id] &&
                      attendanceMediaNote[singleRecord._id][singleHeaderField.name] ? (
                        <div className={`d-flex justify-content-between gap-2`}>
                          {singleHeaderField.populateFunc
                            ? TableUtils[singleHeaderField.populateFunc](
                                value
                                  ? value.split('.').reduce((acc, curr) => acc[curr], singleRecord)
                                  : singleRecord,
                                callbackFunc,
                                singleHeaderField.translateVal ? translateValueFunc : null,
                              )
                            : value && singleRecord
                            ? value.split('.').reduce((acc, curr) => acc[curr], singleRecord)
                            : ''}

                          <img
                            onClick={() => {
                              let singleObj =
                                attendanceMediaNote[singleRecord._id][singleHeaderField.name];
                              if (singleObj.media || singleObj.note) {
                                showMedia(
                                  {
                                    userName:
                                      singleRecord.firstName || singleRecord.lastName
                                        ? singleRecord.firstName + ' ' + singleRecord.lastName
                                        : '',
                                    note: singleObj.note ? singleObj.note : '',
                                    media: singleObj.media ? singleObj.media : [],
                                  },
                                  'form_version_id',
                                  false,
                                  'attendance',
                                );
                              }
                            }}
                            className='cursor-pointer'
                            src={
                              attendanceMediaNote[singleRecord._id][singleHeaderField.name].note ||
                              attendanceMediaNote[singleRecord._id][singleHeaderField.name].media
                                ? attendanceMediaIcon
                                : attendanceMediaGreyIcon
                            }
                          />
                        </div>
                      ) : singleHeaderField.populateFunc ? (
                        TableUtils[singleHeaderField.populateFunc](
                          value
                            ? value.split('.').reduce((acc, curr) => acc[curr], singleRecord)
                            : singleRecord,
                          callbackFunc,
                          singleHeaderField.translateVal
                            ? translateValueFunc
                            : singleHeaderField.filterKey
                            ? singleHeaderField.filterKey
                            : null,
                          singleHeaderField.sendRowWithKeyValue
                            ? { row: singleHeaderField, key: singleHeaderField.name }
                            : null,
                        )
                      ) : value && singleRecord ? (
                        value.split('.').reduce((acc, curr) => acc[curr], singleRecord)
                      ) : (
                        ''
                      )}
                    </td>
                  ) : null;
                })}
                {isActionsEnabled && (
                  <td>{TableUtils['actionsList'](singleRecord, actionsType, actionsCallBack)}</td>
                )}
              </tr>
            );
          })}
      </tbody>
      <AlertModal
        show={showMediaModal}
        closeModal={closeModal}
        showCloseButton
        size='lg'
        actionButtons={[]}
      >
        {showMediaModal ? <AttachmentsOverviewContent mediaAndNotes={mediaAndNotes} /> : <></>}
      </AlertModal>
    </Fragment>
  );
};

TableData.propTypes = {
  selectedRows: PropTypes.array,
  data: PropTypes.array.isRequired,
  tableFields: PropTypes.array.isRequired,
  props: PropTypes.object.isRequired,
  isActionsEnabled: PropTypes.bool.isRequired,
  isSelectionEnabled: PropTypes.bool,
  selectionKey: PropTypes.string,
  onSelection: PropTypes.func,
  cellBorder: PropTypes.string,
  noWrap: PropTypes.bool,
};

export default TableData;
